/**
 * Slider Component
 *
 * @file slider.js
 */

import Swiper from 'swiper';
import SwiperCore, { Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Keyboard, Mousewheel } from 'swiper/core';
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, Controller, Thumbs, Keyboard, Mousewheel]);

import 'swiper/swiper-bundle.css';

const slider = (() => {
  /**
   * fullSlider
   * Full width slider settings
   */
  const fullSlider = () => {
    const homeSlide = new Swiper('.home-slide-carousel', {
      autoplay:true,
      pagination: {
        el: '.home-slide-pagination',
        clickable: true,
      },
    });
  };

  const homePolicySlide = () => {
    const homePolicySlide = new Swiper('.home-quality-policy-carousel ', {
      slidesPerView: 3.8, 
      spaceBetween: 30,
      loop:false,
      autoplay:true,
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 10,
        },
        680: {
          slidesPerView: 2.2,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 3.2,
          spaceBetween: 20,
        },
        1280: {
          slidesPerView: 3.8, 
          spaceBetween: 30,
        },
      },
    });
  }

  const homeMarqueeSlide = () => {
    var textIndentPercent = 10;
    var marqueeCenteringInterval;

    // 'hm-marquee' id'li div'in var olup olmadığını kontrol et
    if (document.getElementById('hm-marquee')) {
        marqueeCenteringInterval = setInterval(function() {
            var marquee = document.getElementById('hm-marquee');
            marquee.style.textIndent = -textIndentPercent + '%';
            textIndentPercent -= 0.0001;
            if (textIndentPercent < 0) {
                marquee.style.textIndent = '0px';
                clearInterval(marqueeCenteringInterval);
            }
        }, 100);
    }
  }

  const init = () => {
    fullSlider();
    homePolicySlide();
    homeMarqueeSlide();
  };

  return {
    init,
  };
})();

export default slider;
